import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex-centered",
  style: {"position":"absolute","width":"100%","height":"100%","top":"0","left":"0","pointer-events":"none"}
}

import { ref } from 'vue';
import { useMotion } from '@vueuse/motion'
import { useModule } from 'src/modules/modules';


export default /*#__PURE__*/_defineComponent({
  __name: 'expanding-circle',
  setup(__props, { expose }) {

_useCssVars(_ctx => ({
  "56143b4a": (_unref(theme).theme.gameBg)
}))

const { theme } = useModule();

/**
 * Leave transition
 */
const circle = ref();
const circleMotion = useMotion(circle, {
    initial: {
        opacity: 0,
        scale: 0
    },
    leave: {
        opacity: 1,
        scale: 30,
        transition: {
            duration: 500,
            ease: 'easeOut'
        }
    }
})

expose({
    leave: () => circleMotion.apply('leave')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "circle",
      ref: circle,
      class: "k-phase-bg-leave"
    }, null, 512)
  ]))
}
}

})